import style from "./ChatTooltip.module.scss";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";

export function ChatTooltip() {
  const onLinkClicked = () => {
    window.open("https://imagica.zendesk.com/hc/en-us/articles/18399149126171-Imagica-Terms-of-Use");
  };

  const { isShare } = useHomeUsePluginContainer();
  const previewCls = isShare ? "" : style.previewTooltip;

  return (
    <div className={`${style.tooltipBox} ${previewCls}`}>
      Please chat to a professional for medical, legal, or financial advice.{" "}
      <span onClick={() => onLinkClicked()}>Read our full disclaimer.</span>
    </div>
  );
}
